export const SET = 'timeReports/SET';



// WEBPACK FOOTER //
// ./app/routes/time-report/store/action-types.js